import { createAction, props } from '@ngrx/store';
import { IBeneficiariesData, IBeneficiariesModel, IBeneficiaryDetails } from '@partners/api';
import { IBeneficiaryFormMode } from './beneficiaries.state';

export class BeneficiariesActions {
  static reset = createAction('[Beneficiaries] Reset State');
  static addBeneficiary = createAction(
    '[Beneficiaries] Add Beneficiary State',
    props<{ beneficiary: IBeneficiaryDetails }>()
  );
  static removeBeneficiary = createAction(
    '[Beneficiaries] Remove Beneficiary State',
    props<{ beneficiary: IBeneficiaryDetails }>()
  );
  static updateBeneficiaryFormMode = createAction(
    '[Beneficiaries] Update Beneficiary Form mode',
    props<{ beneficiaryFormMode: IBeneficiaryFormMode }>()
  );
  static removeAllBeneficiaries = createAction('[Beneficiaries] Remove All Beneficiaries State');
  static updateBeneficiary = createAction(
    '[Beneficiaries] Update Beneficiary State',
    props<{ beneficiary: IBeneficiaryDetails }>()
  );
  static load = createAction('[Beneficiaries] Load');
  static loadSuccess = createAction(
    '[Beneficiaries] Load Success',
    props<{ model: IBeneficiariesModel; data: IBeneficiariesData }>()
  );
  static loadFailure = createAction('[Beneficiaries] Load Failure', props<{ error: any }>());
  static submit = createAction('[Beneficiaries] Submit');
  static submitSuccess = createAction(
    '[Beneficiaries] Submit Success',
    props<{ model: IBeneficiariesModel; data: IBeneficiariesData }>()
  );
  static submitFailure = createAction('[Beneficiaries] Submit Failure', props<{ error: any }>());
  static selectBeneficiary = createAction(
    '[Beneficiaries] Select Beneficiary State',
    props<{ beneficiary: IBeneficiaryDetails }>()
  );
  static resetBeneficiary = createAction('[Beneficiaries] Reset Beneficiary State');
}
